let scroll_bar_width = getScrollbarWidth();
let scroll_bar_half_width = scroll_bar_width/2;

jQuery('body').css('--scroll-bar-half-width', scroll_bar_half_width + 'px');
jQuery(document).ready(function() {
    initGallery();
    addClassHoverCardClickable();
    changeLinkAxeptio();
    readMore();
    removePaddingSameSectionBackground();
    scrollTop();
    toggleAccordion();
    triggerClick();
});

function addClassHoverCardClickable(){
    if(jQuery('.pgut-clickable').length > 0){
        // mouseup plutôt que click pour le clic roulette
        jQuery('.pgut-clickable').mouseup(function(e){
            e.preventDefault();
            // Si on clique sur un sous-menu sans lien ou le ul du sous-menu, on ouvre/ferme le sous-menu en question
            if((jQuery(this).hasClass('wp-block-navigation-item') && jQuery(this).hasClass('has-child')) || jQuery(this).hasClass('wp-block-navigation__submenu-container')){
                var element = jQuery(this);
                if(jQuery(this).hasClass('wp-block-navigation__submenu-container')){
                    var element = jQuery(this).parent();
                }
                if(!element.find('a').eq(0).attr("href") || element.find('a').eq(0).attr("href") == "#"){
                    e.preventDefault();
                    var expanded = element.find('button.wp-block-navigation-submenu__toggle').attr('aria-expanded');
                    if(expanded === "true"){
                        expanded = false
                    }
                    else {
                        expanded = true;
                    }
                    element.find('button.wp-block-navigation-submenu__toggle').attr('aria-expanded',expanded);
                }
                else {
                    window.location.href = jQuery(this).find('a').eq(0).attr("href");
                }
            }
            else {
                if(e.which == 1){
                    // Pour ouvrir dans un nouvel onglet
                    if(jQuery(this).find('a').eq(0).attr("target") == "_blank" ){
                        window.open(jQuery(this).find('a').eq(0).attr("href"));
                    }
                    else {
                        window.location.href = jQuery(this).find('a').eq(0).attr("href");
                    }
                }
                else if(e.which == 2){
                    window.open(jQuery(this).find('a').eq(0).attr("href"));
                }
            }

            e.stopPropagation();
        });
    }
}

/*
 * Implémentation du bouton "readmore"
 */
function readMore(action = 'hide') {
    let elements = jQuery('.js-read-more');

    if (action === 'hide') {
        elements.each(function () {
            let parent = jQuery(this).parent();
            let read_content = parent.nextAll().detach();
            let content_block = jQuery(this).closest('.wp-block-group').find('.js-read-more-content').appendTo(parent.parent());
            read_content.appendTo(content_block);
        });
    }

    elements.click(function (e) {
        e.preventDefault();

        let tl = gsap.timeline();
        tl.to(jQuery(this).parent(), {ease: 'power0', opacity: 0, overflow: 'hidden', display: 'none'});
        tl.to(jQuery(this).parent().next(), {
            ease: 'power0', opacity: 1, height: 'auto', onComplete: function () {
                ScrollTrigger.refresh();
            }
        });
    });
}

function getScrollbarWidth() {

    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}

// Scroll to top of the page
function scrollTop(){
    jQuery('.nr-scroll-top').click(function(){
        jQuery('html, body').animate({scrollTop: '0px'}, 500);
    });
}


function changeLinkAxeptio(){
    if(jQuery('a[href="#manage-axeptio"]').length > 0){
        jQuery('a[href="#manage-axeptio"]').attr('href', 'javascript:openAxeptioCookies()');
    }
}

// Block Accordion - Open / Close
function toggleAccordion() {
    if(jQuery('.pgut-accordion__tab .pgut-accordion__heading').length > 0){
        var accordion_headings = jQuery('.pgut-accordion__tab .pgut-accordion__heading');
        accordion_headings.on('click', function(){
            jQuery(this).parent().toggleClass('pgut-accordion__is-open');
        })
    }
}

// Rendre un élément cliquable alors qu'il ne possède un lien que sur une petite zone
function triggerClick() {
    if(jQuery('.pgut-clickable').length > 0){
        jQuery('.pgut-clickable').mouseenter(function(e){
            jQuery(this).find('.pgut-button').addClass('pgut-button__hover');
        });

        jQuery('.pgut-clickable').mouseleave(function(e){
            jQuery(this).find('.pgut-button').removeClass('pgut-button__hover');
        });

        // mouseup plutôt que click pour le clic roulette
        jQuery('.pgut-clickable').mouseup(function(e){
            if(e.which == 1){
                // Pour ouvrir dans un nouvel onglet
                if(jQuery(this).find('a').eq(0).attr("target") == "_blank" ){
                    window.open(jQuery(this).find('a').eq(0).attr("href"));
                }
                else {
                    window.location.href = jQuery(this).find('a').eq(0).attr("href");
                }
            }
            else if(e.which == 2){
                window.open(jQuery(this).find('a').eq(0).attr("href"));
            }
        });
    }
}

function removePaddingSameSectionBackground(){
    // Si les deux sections l'une à la suite de l'autre ont le même background
    // on enlève un padding
    jQuery('main *:not(.is-layout-grid) > .wp-block-group.has-background').each(function() {
        let $current = jQuery(this);
        let $prev = $current.prev('*:not(.is-layout-grid) > .wp-block-group.has-background');

        // Vérifier si l'élément précédent existe et a une classe
        if ($prev.length && $prev.attr('class')) {
            let currentClasses = $current.attr('class').split(' ');
            let prevClasses = $prev.attr('class').split(' ');

            let currentBackgroundClass = currentClasses.find(c => c.includes('has-') && c.includes('-background-color'));
            let prevBackgroundClass = prevClasses.find(c => c.includes('has-') && c.includes('-background-color'));

            // Appliquer le style si les deux éléments ont une classe de fond correspondante
            if (currentBackgroundClass && prevBackgroundClass && currentBackgroundClass === prevBackgroundClass) {
                $current.css('padding-top', '0');
            }
        }
    });

    // Si les deux sections l'une à la suite de l'autre n'ont pas de background toutes les deux
    // on enlève un padding
    jQuery('main *:not(.is-layout-grid) > .wp-block-group').each(function() {
        let $current = jQuery(this);
        let $prev = $current.prev('*:not(.is-layout-grid) > .wp-block-group');

        // Vérifier si l'élément précédent existe et a une classe
        if ($prev.length && $prev.attr('class')) {
            let currentClasses = $current.attr('class').split(' ');
            let prevClasses = $prev.attr('class').split(' ');
            let currentBackgroundClass = currentClasses.find(c => c.includes('has-') && c.includes('-background-color'));
            let prevBackgroundClass = prevClasses.find(c => c.includes('has-') && c.includes('-background-color'));

            // Appliquer le style si les deux éléments ont une classe de fond correspondante
            if (!currentBackgroundClass && !prevBackgroundClass) {
                $current.css('padding-top', '0');
            }
        }
    });
}

function initGallery(){
    if(jQuery('.pgut-gallery').length > 0){
        if(jQuery('.pgut-gallery__image').length > 0){
            jQuery('.pgut-gallery__image').on('click', function(){
                jQuery('.pgut-gallery__image__selected').removeClass('.pgut-gallery__image__selected');
                jQuery(this).addClass('pgut-gallery__image__selected');

                var src = jQuery(this).attr('src');
                jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__image').attr('src', src);
            });

            jQuery('.pgut-gallery__arrow-prev').on('click', function(){
                var current_selected_img = jQuery('.pgut-gallery__image__selected');
                if(current_selected_img.prev().length > 0){
                    var offset = current_selected_img.prev().offset();
                    var scroll_left = jQuery('.pgut-gallery__thumbnails').scrollLeft();

                    jQuery('.pgut-gallery__thumbnails').scrollLeft(offset.left + scroll_left);

                    current_selected_img.removeClass('pgut-gallery__image__selected');
                    current_selected_img.prev().addClass('pgut-gallery__image__selected');

                    var src = current_selected_img.prev().attr('src');
                    jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__image').attr('src', src);
                }
            });

            jQuery('.pgut-gallery__arrow-next').on('click', function(){
                var current_selected_img = jQuery('.pgut-gallery__image__selected');
                if(current_selected_img.next().length > 0){
                    var offset = current_selected_img.next().offset();
                    var scroll_left = jQuery('.pgut-gallery__thumbnails').scrollLeft();

                    jQuery('.pgut-gallery__thumbnails').scrollLeft(offset.left + scroll_left);

                    current_selected_img.removeClass('pgut-gallery__image__selected');
                    current_selected_img.next().addClass('pgut-gallery__image__selected');

                    var src = current_selected_img.next().attr('src');
                    jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__image').attr('src', src);
                }

            });
        }
    }
}
